import React, { createContext } from 'react';
import isEqual from 'lodash/isEqual';
import memoizeOne from 'memoize-one';

import type { EditorActions } from '@atlaskit/editor-core';

import type { TriggerAnalyticsEventType } from '@confluence/editor-features';

export type EditorObjectHeaderContextType = {
	saveDraft: ({ isOnClose }: any) => Promise<void>;
	navigateOnClose: (args?: { isDiscarding?: boolean }) => void;
	triggerAnalyticsEvent: TriggerAnalyticsEventType;
	version: number;
	editorActions: EditorActions;
	title: string | null;
};

export type EditorObjectHeaderContextProviderProps = {
	value: EditorObjectHeaderContextType;
	children?: React.ReactNode;
};

const EditorObjectHeaderContext = createContext<EditorObjectHeaderContextType | null>(null);

const memoizeDeepEq = memoizeOne(<T,>(obj: T) => obj, isEqual);

export const EditorObjectHeaderContextProvider = ({
	children,
	value,
}: EditorObjectHeaderContextProviderProps) => {
	const memoizedValue = memoizeDeepEq(value);
	return (
		<EditorObjectHeaderContext.Provider value={memoizedValue}>
			{children}
		</EditorObjectHeaderContext.Provider>
	);
};

export const useEditorObjectHeaderContext = () => {
	const context = React.useContext(EditorObjectHeaderContext);
	if (!context) {
		throw new Error(
			'useEditorObjectHeaderContext must be used within a EditorObjectHeaderContextProvider',
		);
	}
	return context;
};
